// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getAuth } from "firebase/auth";
import { doc, getFirestore, setDoc } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA5vIT-talQ7L8HM1qnIPOxPMO7i4LXgXs",
  authDomain: "schoole-managment-system.firebaseapp.com",
  projectId: "schoole-managment-system",
  storageBucket: "schoole-managment-system.appspot.com",
  messagingSenderId: "303405370178",
  appId: "1:303405370178:web:1c333beaae69e4862c16db",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Cloud functions
export const functions = getFunctions(app);
// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Messaging
export const messaging = getMessaging(app);

let publicKey =
  "BP8dkWeuz9YwneDynFVJINxeH09mC383f084KaQ5g1gGcdwNKIokAWNzsIJm3tSOKPw6e24lxMxrlSLbsmfUOus";
export const getTokenFromFirebase = async (setTokenFound) => {
  let currentToken = "";
  let eError = "";
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    getToken(messaging, { vapidKey: publicKey })
      .then(async (currentToken) => {
        // console.log("currentToken", currentToken);
        if (currentToken) {
          const userId = getAuth()?.currentUser?.uid;
          try {
            const deviceIdCollection = await doc(
              db,
              "DeviceIds",
              userId,
              "device_ids",
              currentToken
            );
            await setDoc(deviceIdCollection, {
              token: currentToken,
            });
          } catch (error) {
            console.log(error);
          }
          setTokenFound(true);
        } else {
          setTokenFound(false);
        }
      })
      .catch((err) => {
        eError = err;
        console.log("An error occurred while retrieving token. ", eError);
        // ...
      });
  } else if (permission === "denied") {
    // alert("You denied for the notification");
  }

  return currentToken;
};

// DB
export const db = getFirestore(app);

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log(messaging);
      resolve(payload);
    });
  });

onMessageListener();
